import { useMutation } from '@tanstack/react-query'
import { putContact } from 'services/ContactService'

export const usePutContactMutation = () => {
  return useMutation({ mutationFn: putContact })
}
